/**
 * @fileoverview GET handler for the "/custom_objects/custom_object_type_schema" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsCustomObjectTypeSchema } from "./constants";
import type { GetCustomObjectsCustomObjectTypeSchemaResult } from "./types";
import { isGetCustomObjectsCustomObjectTypeSchemaResult } from "./validators";

export const getCustomObjectsCustomObjectTypeSchema = reactQueryFetcherAdapter(
  customObjectsCustomObjectTypeSchema,
  (signal: AbortSignal, typeName: string): Promise<GetCustomObjectsCustomObjectTypeSchemaResult> => {
    return fetch(
      "/custom_objects/custom_object_type_schema",
      "GET",
      { type_name: typeName },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsCustomObjectTypeSchemaResult
);
